/** Fontes de dados disponíveis para relatórios. */

export const FONTE_CHAMADOS_TECNICOS = 'chamados_tecnicos';
export const FONTE_PARQUE_LOCADO = 'parque_locado';
export const FONTE_PRODUCAO_VOLUMETRIA = 'producao_volumetria';

/** Fontes que podem ser escolhidas como principal em "Novo relatório". */
export const FONTES_PRIMARY_OPTIONS = [
  {
    id: FONTE_CHAMADOS_TECNICOS,
    label: 'Chamados técnicos',
    description:
      'Crie um relatório que reúna todas as informações disponíveis sobre as ordens de serviço',
    enabled: true,
  },
  {
    id: FONTE_PARQUE_LOCADO,
    label: 'Parque locado',
    description:
      'Crie um relatório capaz de reunir, em um único lugar, as informações dos equipamentos locados, os dados relacionados às ordens de serviço e os dados de produção (volumetria), permitindo uma análise completa.',
    enabled: true,
  },
];

/** Todas as fontes (inclui complementares). */
export const FONTES_DADOS_OPTIONS = [
  ...FONTES_PRIMARY_OPTIONS,
  {
    id: FONTE_PRODUCAO_VOLUMETRIA,
    label: 'Produção (volumetria)',
    description: 'Volumetria mensal por contrato e série',
    enabled: false,
  },
];

/** Opções de periodo_tipo no wizard "Novo relatório" (valores: abertura | fechamento). */
export const PERIOD_TIPO_OPTIONS_BY_FONTE = {
  [FONTE_CHAMADOS_TECNICOS]: [
    { id: 'abertura', label: 'Data de abertura da ordem de serviço' },
    { id: 'fechamento', label: 'Data de fechamento da ordem de serviço' },
  ],
  [FONTE_PARQUE_LOCADO]: [
    { id: 'abertura', label: 'Data de instalação do equipamento' },
    { id: 'fechamento', label: 'Data de desinstalação do equipamento' },
    {
      id: 'semperiodo',
      label: 'Todo o parque independente de períodos',
    },
  ],
};

export function getPeriodoTipoOptionsForFonte(fonteId) {
  return (
    PERIOD_TIPO_OPTIONS_BY_FONTE[fonteId] ||
    PERIOD_TIPO_OPTIONS_BY_FONTE[FONTE_CHAMADOS_TECNICOS]
  );
}
